import { Component } from '@angular/core';
import { PopoverController } from 'ionic-angular';
import { OptionsComponent } from '../../components/options/options';

@Component({
    selector: 'page-producao',
    templateUrl: 'producao.html',
})
export class ProducaoPage { 
    public analytic: boolean = true;

    constructor(private _popoverCtrl: PopoverController) { }

    public showOptions(ev: any): void {
        let reactions = this._popoverCtrl.create(OptionsComponent, { analytic: this.analytic });

        reactions.onWillDismiss(analytic => {
            if (analytic != null)
                this.analytic = analytic;
        });

        reactions.present({ ev: ev });
    }
}


// WEBPACK FOOTER //
// ./src/pages/producao/producao.ts